import { render } from "./modalAlertIA.vue?vue&type=template&id=b3c37294&scoped=true"
import script from "./modalAlertIA.vue?vue&type=script&lang=js"
export * from "./modalAlertIA.vue?vue&type=script&lang=js"

import "./modalAlertIA.vue?vue&type=style&index=0&id=b3c37294&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b3c37294"

export default script